import React from 'react';
import '../styles/Loader.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLandmark, faBuildingColumns } from '@fortawesome/free-solid-svg-icons';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="transaction-loader">
        <FontAwesomeIcon icon={faBuildingColumns} className="bank-icon left-bank" />
        <div className="zebra-path" />
        <FontAwesomeIcon icon={faLandmark} className="bank-icon right-bank" />
      </div>
    </div>
  );
};

export default Loader;
